import { getCategoryName } from "@models";
import { useStore } from "@stores";
import { useEffect } from "react";

export const useTownCategories = (townId: number | undefined) => {
  const { categoryStore } = useStore();

  useEffect(() => {
    if (townId) {
      categoryStore.getByTown(townId);
    }
  }, [categoryStore, townId]);

  return {
    categories: categoryStore.townCategories,
    loading: categoryStore.townLoading,
    loaded: categoryStore.townLoaded,
    getCategoryName,
  };
};
